import { ReactNode } from "react";
import { Text } from "../Atoms/Text";
import {
  CenterContainer,
  LeftContainer,
  RightContainer,
  SimpleContainer,
} from "../styles/styles";

interface SimpleListContainerProps {
  headline: string;
  subtext?: string;
  leftcontent?: ReactNode;
  rightcontent?: ReactNode;
}

export const SimpleListContainer = ({
  headline,
  subtext,
  leftcontent,
  rightcontent,
}: SimpleListContainerProps) => {
  return (
    <SimpleContainer $direction={"row"}>
      <LeftContainer>
        <>{leftcontent}</>
      </LeftContainer>
      <CenterContainer $centerText={false}>
        <div style={{ display: "flex" }}>
          <Text text={headline} bold />
        </div>
        {subtext && <Text text={subtext} grey />}
      </CenterContainer>
      <RightContainer>
        <>{rightcontent}</>
      </RightContainer>
    </SimpleContainer>
  );
};
